module.exports = __webpack_public_path__ + "6427d9c4ce61ec28be3d0c36dda4616b.png";